import {useFormContext} from 'react-hook-form';
import {Info} from 'lucide-react';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@common-web/components/ui/form';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@common-web/components/ui/tooltip';
import {FIELD_INPUT_CLASS} from '@client/pages/public/enroll/checkout/fields/fieldStyles';

export function TextField({
  name,
  label,
  type = 'text',
  placeholder,
  autoComplete,
  inputMode,
  hint,
  className,
}: {
  name: string;
  label: string;
  type?: string;
  placeholder?: string;
  autoComplete?: string;
  inputMode?: 'text' | 'tel' | 'email' | 'numeric';
  hint?: string;
  className?: string;
}) {
  const {control} = useFormContext();
  return (
    <FormField
      control={control}
      name={name}
      render={({field}) => (
        <FormItem className={className}>
          <FormLabel className='flex items-center gap-1'>
            {label}
            {hint && (
              <TooltipProvider delayDuration={150}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <button
                      type='button'
                      aria-label={`${label} info`}
                      onClick={(event) => event.preventDefault()}
                      className='inline-flex cursor-help text-neutral-400'
                    >
                      <Info className='h-3.5 w-3.5' />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent className='max-w-[260px] bg-slate-900 px-3.5 py-2.5 text-sm font-normal leading-snug text-white'>
                    {hint}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </FormLabel>
          <FormControl>
            <input
              {...field}
              type={type}
              placeholder={placeholder}
              autoComplete={autoComplete}
              inputMode={inputMode}
              className={FIELD_INPUT_CLASS}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
